import Jump from 'jump.js'
import { easeOutQuad } from 'ez.js';

const scrollToTop = document.querySelector('.js-scroll-to-top');
const contactButton = document.querySelector('.contact-button');
const className = 'is-active';
let timeout;

if (scrollToTop) {

  window.addEventListener('scroll', () => {
    // debounce to prevent to much event
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if(scrollToTop.classList.contains(className)) {
        contactButton.classList.add(className);
      } else {
        contactButton.classList.remove(className);
      }
    }, 50);
  });
}
